// Must equal MIN_PASSWORD_LENGTH in appquickchat/api/accounts/base_router.py; above Django's MinimumLengthValidator default of 8 so that stays the binding rule.
export const PASSWORD_MIN_LENGTH = 10;
